import {useCallback} from 'react';
import {produce} from 'immer';
import set from 'lodash/set';
import type {DataValue} from 'schemaDefinition/types';
import {useAppDispatch, useAppStore} from 'store/hooks';
import {metadataEditChangeRequestEdited} from '../metadataEditSlice';

export const useSetChangeRequestEditValue = (entityId: string) => {
  const dispatch = useAppDispatch();
  const {getState} = useAppStore();

  return useCallback(
    (valuePath: string, value: DataValue) => {
      const metadata = getState().metadataEdit.metadata;
      const changeRequest = (metadata?.changeRequests ?? []).find(
        cr => cr.id.toString() === entityId,
      );

      if (!changeRequest || !metadata) {
        return null;
      }

      const updatedChangeRequest = produce(changeRequest, draft => {
        set(draft, valuePath, value);
      });

      dispatch(metadataEditChangeRequestEdited(updatedChangeRequest));
    },
    [dispatch, entityId, getState],
  );
};
